<template>
  <div class="fullheight" :style="{ paddingTop: tenantId && tenantId != -1 ? 0 : '16px', height: 'calc(100% - 16px)' }">
    <el-tabs class="aa" v-model="activeName" @tab-click="handleClick" v-if="tenantId && tenantId != -1">
      <!-- v-if="tenantId && tenantId != -1" -->
      <el-tab-pane label="我的模板" name="first"></el-tab-pane>
      <el-tab-pane label="模板库" name="second"></el-tab-pane>
    </el-tabs>
    <el-container
      class="fullheight"
      style="border: 1px solid #eee"
      :style="{
        height: height
      }"
    >
      <el-aside class="fullheight" :width="width" v-show="asideShow">
        <p class="titP" style="padding-left: 20px">模板名称</p>
        <fe-sys-type-tree
          class="fe-sys-type-tree"
          highlight-current
          ref="ecoDataDicTree"
          :support-filter="supportFilter"
          :default-expand-all="isExpand"
          :tabIndex="activeName"
          expand-on-click-node="false"
          @node-click="handleNodeClick"
          managePlanKey="3"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span :class="[checkCanEdit() ? 'show-ellipsis-spec' : 'show-ellipsis-spec-len']" :title="node.label">{{ `${node.label}` }}</span>
            <template v-if="checkCanEdit()">
              <span>{{ !data.state ? '启用' : '禁用' }}</span>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'addChild' }">新增阶段</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'edit' }">编辑模板</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-delete" :command="{ node: node, data, action: 'delete' }">删除模板</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'referTemplate' }">引用模板</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </span>
        </fe-sys-type-tree>
      </el-aside>
      <el-container>
        <el-main class="fullheight">
          <p class="titP titP2">
            <em class="em1">任务名称</em>
          </p>
          <el-scrollbar class="dic-data-scrollbar">
            <eco-tree
              :data="dicDatas"
              node-key="id"
              :props="defaultProps"
              :support-filter="false"
              :expand-on-click-node="false"
              :default-expand-all="isExpandDic"
              ref="dicDataTree"
            >
              <!-- 作用域插槽：插槽prop -->
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <!-- <span>{{ data.sort + "、" }}</span> -->
                <span class="show-ellipsis" :title="node.label">
                  <em class="em1">{{ node.label }}</em>
                </span>
                <el-dropdown @command="handleCommand" v-if="checkCanEdit()">
                  <span class="el-dropdown-link">
                    <img src="@/assets/img/iconMore.png" class="iconMore" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- 二级 -->
                    <el-dropdown-item icon="el-icon-edit" v-if="!data.stage_id" :command="{ node: node, data, action: 'dicAdd' }">新增任务</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-edit" v-if="!data.stage_id" :command="{ node: node, data, action: 'editChild' }">编辑</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" v-if="!data.stage_id" :command="{ node: node, data, action: 'dicDelete' }">删除</el-dropdown-item>
                    <!-- 三级 -->
                    <el-dropdown-item icon="el-icon-edit" v-if="data.stage_id" :command="{ node: node, data, action: 'dicEdit' }">编辑</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" v-if="data.stage_id" :command="{ node: node, data, action: 'dicDelete' }">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </eco-tree>
          </el-scrollbar>
        </el-main>
      </el-container>
      <div class="i_export">
        <el-button v-loading="loading" @click="addKey" v-if="checkCanEdit()">新增模板</el-button>
      </div>
    </el-container>
    <!-- 新增模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="sysType" data-vv-scope="sysTypeForm" style="padding: 20px">
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="sysType.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
        <eco-form-item label="状态" label-width="100px">
          <eco-radio
            validate="required"
            v-model="sysType.state"
            :options="[
              { key: 0, value: '启用' },
              { key: 1, value: '禁用' }
            ]"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveSysTypeUrl" :model="sysType" scope-name="sysTypeForm" @error-save-data="errorSaveData" @after-save-data="afterSaveData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisibleEdit" :before-close="handleClose" append-to-body>
      <el-form style="padding: 20px" :model="editSysType" data-vv-scope="editSysTypeForm">
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="editSysType.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
        <eco-form-item label="状态" label-width="100px">
          <eco-radio
            validate="required"
            v-model="editSysType.state"
            :options="[
              { key: 0, value: '启用' },
              { key: 1, value: '禁用' }
            ]"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleEdit = false">取 消</el-button>
        <fe-submit-button
          :url="saveSysTypeUrlEdit"
          :model="editSysType"
          scope-name="editSysTypeForm"
          requestMethod="PUT"
          @error-save-data="errorSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 新增阶段 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="dialogVisibleChild" :before-close="handleClose" append-to-body>
      <el-form :model="dicDataFirst" data-vv-scope="dicDataFirstForm" style="padding: 20px">
        <eco-form-item label="阶段顺序" label-width="85px">
          <eco-input
            v-model="dicDataFirst.sort"
            autocomplete="off"
            placeholder="请输入阶段顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="阶段名称" label-width="85px">
          <eco-input v-model="dicDataFirst.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入阶段名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleChild = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrl"
          :model="dicDataFirst"
          scope-name="dicDataFirstForm"
          @error-save-data="errorSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑阶段 -->
    <eco-sidebar-dialog width="28%" :title="dicTitle" :visible="dialogVisibleChildEdit" :before-close="handleClose" destroy-on-close append-to-body>
      <el-form :model="editDicDataFirst" data-vv-scope="editDicDataForm" style="padding: 20px">
        <eco-form-item label="阶段顺序" label-width="85px">
          <eco-input
            v-model="editDicDataFirst.sort"
            autocomplete="off"
            placeholder="请输入阶段顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <!-- <eco-form-item label="阶段编号" label-width="85px">
            <eco-input
              v-model="editDicData.key"
              v-pinyin="editDicData.name"
              autocomplete="off"
              :validate="{ required: true, alpha_num: true, max: 200 }"
            ></eco-input>
          </eco-form-item> -->
        <eco-form-item label="阶段名称" label-width="85px">
          <eco-input v-model="editDicDataFirst.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入阶段名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleChildEdit = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrlEdit"
          :model="editDicDataFirst"
          requestMethod="PUT"
          scope-name="editDicDataForm"
          @error-save-data="errorSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 新增任务 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="dicDialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="dicData" data-vv-scope="editDic1" style="padding: 20px">
        <eco-form-item label="阶段名称" label-width="100px">
          <eco-input v-model="dicData.parentName" autocomplete="off" disabled> </eco-input>
        </eco-form-item>
        <eco-form-item label="任务顺序" label-width="100px">
          <eco-input
            v-model="dicData.sort"
            autocomplete="off"
            placeholder="请输入任务顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="任务名称" label-width="100px">
          <eco-input v-model="dicData.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入任务名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dicDialogVisible = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrl"
          :model="dicData"
          scope-name="editDic1"
          @error-save-data="errorSaveDicData"
          @after-save-data="afterSaveDicData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑任务 -->
    <eco-sidebar-dialog width="28%" destroy-on-close :title="dicTitle" :visible="editDicDialogVisible" :before-close="handleCloseEdit" append-to-body>
      <el-form :model="editDicData" data-vv-scope="editDic2" style="padding: 20px">
        <eco-form-item label="阶段名称" label-width="100px">
          <eco-input v-model="editDicData.parentName" autocomplete="off" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="阶段顺序" label-width="100px">
          <eco-input
            v-model="editDicData.sort"
            autocomplete="off"
            placeholder="请输入阶段顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="任务名称" label-width="100px">
          <eco-input v-model="editDicData.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入任务名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="editDicDialogVisible = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrlEdit"
          requestMethod="PUT"
          :model="editDicData"
          scope-name="editDic2"
          @error-save-data="errorSaveDicData"
          @after-save-data="afterSaveDicData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 引用模板 -->
    <eco-sidebar-dialog width="28%" destroy-on-close :title="title" :visible="referVisible" :before-close="handleReferClose" append-to-body>
      <el-form :model="referType" data-vv-scope="referTypeForm" style="padding: 20px">
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="referType.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="referVisible = false">取 消</el-button>
        <fe-submit-button :url="saveReferTypeUrl" :model="referType" scope-name="referTypeForm" @after-save-data="afterSaveRefData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
const eipUserSelector = () => import('@/components/selector/EipUserSelector.vue')
import portalApi from '@/api/portal'
import styles from '@/assets/css/element-variables.scss'
import managePlan from '@/api/managePlan.js'
const feSysTypeTree = () => import('@/components/common/FeSysTypeTree.vue')
export default {
  components: {
    feSysTypeTree,
    eipUserSelector
  },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    },
    supportFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeName: 'first',
      height: '100%',

      dicParentId: '', //存储数据字典父类id用于刷新数据字典树
      title: '新增营销模板',
      dicTitle: '新增科目',
      asideShow: true,
      isExpand: true,
      isExpandDic: true,
      dialogVisible: false,
      dialogVisibleEdit: false,
      dialogVisibleChild: false,
      dialogVisibleChildEdit: false,
      dicDialogVisible: false,
      editDicDialogVisible: false,
      referVisible: false,
      dialogImportVisible: false,
      fullscreenLoading: false,
      fileList: [],
      sysType: {
        // 新增模板弹框表单
        state: 0,
        name: '',
        type: 2,
        pro_type: 3
      },
      editSysType: {
        // 编辑模板弹框表单
        name: '',
        type: 2
      },
      dicDataFirst: {
        // 新增阶段弹框表单
        name: '',
        sort: null,
        type: 1
      },
      editDicDataFirst: {
        // 编辑阶段弹框表单
        name: '',
        sort: null
      },
      dicData: {
        // 新增任务弹框表单
        // key: "", //编号
        name: '', // 任务名称
        stage_id: '', // 父id
        template_id: '',
        sort: null, // 阶段顺序
        type: 2
      },
      backStr: '',
      conPerson: '',
      conPersonOptions: [],
      editDicData: {
        // 编辑任务弹框表单
        name: '', // 任务名称
        stage_id: '', // 父id
        template_id: '',
        sort: null, // 阶段顺序
        type: 2
      },

      referType: {
        // 引用模板弹框表单
        name: '',
        sysTemplateId: ''
      },

      treeData: [],
      defaultProps: {
        children: 'stageList',
        label: 'name'
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      bpmForm: {
        key: '',
        bos: '',
        desc: ''
      },
      dicDatas: [],
      loading: false,
      maxlength: 20,
      tenantId: '',
      sort: null
    }
  },
  computed: {
    // 新增模板
    saveSysTypeUrl: function () {
      return `${window.context.work}/planning/project_manager_planning_template/`
    },
    // 编辑模板
    saveSysTypeUrlEdit: function () {
      return `${window.context.work}/planning/project_manager_planning_template/`
    },
    // 引用模板
    saveReferTypeUrl: function () {
      return `${window.context.work}/planning/project_manager_planning_template/sys_template_to_self/`
    },
    // 新增阶段/任务
    saveDicDataUrl: function () {
      return `${window.context.work}/planning/project_manager_planning_template_detail/`
    },
    // 编辑任务
    saveDicDataUrlEdit: function () {
      return `${window.context.work}/planning/project_manager_planning_template_detail/`
    }
  },
  mounted() {
    this.getDic('zw')
    // debugger
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
    this.height = this.tenantId && this.tenantId != -1 ? 'calc(100% - 56px)' : '100%'
    if (this.tenantId && this.tenantId != -1) {
      this.activeName = 'first'
    } else {
      this.activeName = 'second'
    }
  },
  methods: {
    getDic(key) {
      portalApi.getByTypeKey(key).then((response) => {
        this.conPersonOptions = response
        console.log(response, '职位')
      })
    },
    // tab切换
    handleClick(tab) {
      this.templateData = []
      this.activeName = tab.name
      this.$nextTick(() => {
        this.$refs.ecoDataDicTree.loadData()
        this.dicDatas = []
      })
    },
    addKey() {
      this.dialogVisible = true
      this.title = '新增营销模板'
    },
    handleNodeClick(node) {
      this.dicLoadData(node.id)
    },
    dicLoadData(id) {
      if (this.activeName === 'first') {
        managePlan.getmpTemplateDetail(id).then((data) => {
          if (data) {
            //数据转换成树 children格式
            this.dicParentId = id
            this.dicDatas = data.value
            console.log(data, 'ssssssssssssss')
          }
        })
      } else {
        managePlan.getmpPublicTemplateDetail(id).then((data) => {
          if (data) {
            //数据转换成树 children格式
            this.dicParentId = id
            this.dicDatas = data.value
          }
        })
      }
    },
    handleCommand(command) {
      let data = command.data
      let action = command.action
      let newDicdata
      switch (action) {
        case 'add':
          this.title = '新增营销模板'
          this.dialogVisible = true
          break
        case 'edit':
          newDicdata = {}
          this.title = '编辑营销模板'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.editSysType = newDicdata
          this.editSysType.state = this.editSysType.state
          this.editSysType.id = this.editSysType.id
          this.dialogVisibleEdit = true
          break
        case 'addChild':
          this.dicTitle = '新增阶段'
          this.dialogVisibleChild = true
          this.dicDataFirst.template_id = data.id
          break
        case 'editChild':
          newDicdata = {}
          this.dicTitle = '编辑阶段'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.editDicDataFirst = newDicdata
          this.dialogVisibleChildEdit = true
          break
        case 'import':
          newDicdata = {}
          Object.assign(newDicdata, data)
          this.sysType = newDicdata
          this.dialogImportVisible = true
          break
        case 'delete':
          if (data.id) {
            this.$confirm(`是否确定删除 [${data.name}]  及其子分类（包含分类下数据）?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              managePlan
                .delManagerPlanTemplate(data.id)
                .then((resp) => {
                  let data = resp
                  if (data.state) {
                    this.$message({
                      type: 'success',
                      message: data.message || '删除成功'
                    })

                    this.$refs.ecoDataDicTree.loadData()
                    this.syncDicTree()
                    this.dicDatas = null
                  } else {
                    // this.$message.error(data.message || "删除失败");
                  }
                })
                .catch(() => {
                  this.dialogVisible = false
                })
            })
          }
          break
        case 'dicAdd': //数据字典添加
          this.dicTitle = '新增任务'
          this.dicDialogVisible = true
          this.dicData.parentName = data.name
          this.dicData.stage_id = data.id
          this.dicData.template_id = this.dicParentId
          this.dicData.executor_name = ''
          this.dicData.executor_id = ''
          break
        case 'dicDelete':
          if (data.id) {
            this.$confirm(`是否确定删除 [${data.name}] ?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              managePlan
                .delManagerPlanTemplateDetail(data.id)
                .then((data) => {
                  if (data.state) {
                    this.$message({
                      type: 'success',
                      message: data.message || '删除成功'
                    })
                    this.$refs.ecoDataDicTree.loadData()
                    this.syncDicTree()
                  } else {
                    // this.$message.error(data.message || "删除成功");
                  }
                })
                .catch(() => {
                  this.dicDialogVisible = false
                })
            })
          }
          break
        case 'dicEdit':
          newDicdata = {}
          this.dicTitle = '编辑任务'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          delete newDicdata.executor_id
          delete newDicdata.executor_name
          this.editDicData = newDicdata
          this.editDicData.id = data.id
          this.editDicDialogVisible = true
          this.editDicData.parentName = this.dicDatas.find((x) => x.id === data.stage_id).name
          break

        case 'referTemplate':
          this.title = '引用模板'
          newDicdata = {}
          Object.assign(newDicdata, data)
          //   this.referType = newDicdata;
          this.referType.sysTemplateId = newDicdata.id
          this.referType.name = newDicdata.name
          this.referVisible = true
          break

        default:
          break
      }
    },
    handleReferClose() {
      this.referVisible = false
    },
    syncTree() {
      this.$refs.ecoDataDicTree.loadData()
    },
    syncDicTree() {
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisibleChild = false
      this.dialogVisibleEdit = false
      this.dialogVisibleChildEdit = false
      this.dicDialogVisible = false
    },
    handleCloseEdit() {
      this.editDicDialogVisible = false
    },
    afterSaveData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
      // 编辑
      if (this.editSysType.id || this.editDicDataFirst.id) {
        // 模版
        this.editSysType = {}
        this.dialogVisibleEdit = false
        // 一级阶段
        this.editDicDataFirst = {}
        this.dialogVisibleChildEdit = false
        return
      }

      // 新增
      // 模版
      this.sysType.name = ''
      this.dicDataFirst.state = ''
      // 一级阶段
      this.dicDataFirst.name = ''
      this.dicDataFirst.sort = null
      // 二级任务
      this.dicData.name = ''
      this.dicData.sort = null
      ;(this.dicDatastage_id = ''),
        (this.dicDatatemplate_id = ''),
        (this.dicDatasort = null),
        (this.dicDataexecutor_name = ''),
        (this.dicDataexecutor_id = ''),
        // this.$confirm("是否继续?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "success"
        // })
        //   .then(() => {})
        //   .finally(() => {
        //     this.dialogVisible = false;
        //     this.dialogVisibleEdit = false;
        //     this.dialogVisibleChild = false;
        //     this.dialogVisibleChildEdit = false;
        //   });
        (this.dialogVisible = false)
      this.dialogVisibleEdit = false
      this.dialogVisibleChild = false
      this.dialogVisibleChildEdit = false
      this.dicDialogVisible = false
      this.editDicDialogVisible = false
    },
    errorSaveData() {
      // 后端异常处理
      // 模版
      this.sysType.name = ''
      this.dicDataFirst.state = ''
      // 一级阶段
      this.dicDataFirst.name = ''
      this.dicDataFirst.sort = null
    },
    afterSaveRefData() {
      this.$refs.ecoDataDicTree.loadData()
      this.referVisible = false
    },
    afterSaveDicData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
      // 任务
      this.editDicDialogVisible = false

      // 二级阶段
      this.dicData.name = ''
      this.dicData.sort = null
      ;(this.dicDatastage_id = ''), (this.dicDatatemplate_id = ''), (this.dicDatasort = null), (this.dicDataexecutor_name = ''), (this.dicDataexecutor_id = '')
      // this.$confirm("是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "success"
      // })
      //   .then(() => {})
      //   .catch(() => {
      //     this.dicDialogVisible = false;
      //     this.editDicDialogVisible = false;
      //   });
      this.dialogVisible = false
      this.dialogVisibleEdit = false
      this.dialogVisibleChild = false
      this.dialogVisibleChildEdit = false
      this.dicDialogVisible = false
      this.editDicDialogVisible = false
    },
    errorSaveDicData() {
      // 后端异常处理
      // 模版
      // 二级阶段
      this.dicData.name = ''
      this.dicData.sort = null
    },
    /**
     * 判断是否能编辑
     */
    checkCanEdit() {
      if (this.activeName === 'second') {
        return this.tenantId === '-1'
      } else {
        return true
      }
    },
    // 获取施工动态岗位
    changeConPerson(val) {
      console.log(val, val.key, '选中的值')
      let obj = {}
      obj = this.conPersonOptions.find((item) => {
        return item.key === val
      })
      console.log(obj, 'obj')
      this.dicData.executor_name = obj.name
      this.dicData.executor_id = val
      this.editDicData.executor_name = obj.name
      this.editDicData.executor_id = val
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0px;
}
>>> .navbar-collapse {
  position: absolute;
  top: 41%;
  cursor: pointer;
  z-index: 999;
  width: 20px;
}

>>> .el-dropdown {
  display: none;
}

>>> .el-tree-node__content:hover .el-dropdown {
  display: inline-block;
}

>>> .navbar-collapse:hover {
  transform: scale(1.1) translateY(2px);
}

>>> .navbar-collapse:hover .navbar-collapse-arrow {
  color: #333333;
}

>>> .navbar-collapse-arrow {
  position: absolute;
  top: 38%;
  right: -3px;
  font-size: 18px;
  color: #a8a8a8;
}

>>> .navbar-collapse-bg {
  -webkit-transition: all 0.12s ease;
  height: 50px;
  border-bottom: 8px solid transparent;
  border-right: none;
  border-left: 12px solid #ebebeb;
  border-top: 8px solid transparent;
  opacity: 0.9;
}
.el-aside-footer {
  position: absolute;
  bottom: 21px;
}
.i_export {
  margin-top: 15px;
  margin-right: 15px;
}
>>> .custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-node i {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover i {
  visibility: visible;
}

.dic-data-scrollbar {
  width: 250px;
  height: calc(100% - 49px);
  border-right: 1px solid #eee;
}
.titP {
  display: flex;
  margin: 0;
  padding: 10px 0;
  background-color: #f9f9f9;
  em {
    font-style: normal;
  }
  .em1 {
    flex: 0.6;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .em2 {
    flex: 0.4;
  }
}
.titP2 {
  width: 250px;
}

.dic-data-scrollbar >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.show-ellipsis-spec {
  width: calc(100% - 52px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.show-ellipsis-spec-len {
  width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.show-ellipsis {
  display: flex;
  em {
    font-style: normal;
  }
  .em1 {
    flex: 0.6;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .em2 {
    flex: 0.4;
  }
}
.custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 14px;
  padding-right: 8px;
}
/deep/.aa > .el-tabs__header {
  margin: 0;
}
</style>
